import styles from "./examplesResults.module.scss";
import Image from "next/image";
import { capitalizeFirstLetter } from "../../../utils/capitalizeFirstLetter";
import { useEffect, useState } from "react";

const ExamplesResultItem = ({ item, t, type }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div className={`${styles.item} ${styles[type]}`}>
			<Image className={`${styles.img} ${loaded ? "" : styles.load}`} width={240} height={240} src={item.imgUrl} alt={"Result"} quality={100} onLoadingComplete={() => setLoaded(true)} priority />
			<h4 className={styles.name}>{t[item.name] || item.name}</h4>
		</div>
	);
};

const ExamplesResults = ({ type, activeList, t }) => {
	const [list, setList] = useState([]);

	useEffect(() => {
		if (activeList === null) return;

		setList(type === "photo" ? [{ name: "Original", imgUrl: activeList?.originalUrl }, ...activeList?.result] : activeList?.result);
	}, [activeList?.result]);

	return (
		<div className={styles.results}>
			<h3 className={styles.title}>{capitalizeFirstLetter(t["results"] || "Results")}</h3>
			<div className={`${styles.itemsWrapper} ${type}`}>
				{list?.map((item) => (
					<ExamplesResultItem key={item.imgUrl} item={item} t={t} type={type} />
				))}
			</div>
		</div>
	);
};

export default ExamplesResults;
